var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,6.4A14.82,14.82,0,0,0,1,11.33v1.34a14.76,14.76,0,0,0,22,0V11.33A14.82,14.82,0,0,0,12,6.4Zm0,9.2A12.8,12.8,0,0,1,3.12,12,12.94,12.94,0,0,1,8.63,8.87,3.89,3.89,0,0,0,8,11a4,4,0,0,0,8,0,3.89,3.89,0,0,0-.63-2.13A12.94,12.94,0,0,1,20.88,12,12.8,12.8,0,0,1,12,15.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/1779968102/media/icon-eye.5c03ebe700cccbf26cc92fc38d96491f.svg";
export { ForwardRef as ReactComponent };